
import { Vue, Component } from "vue-property-decorator";
import dayjs from "dayjs";
@Component({
  name: "addBrand",
})

export default class addBrand extends Vue {
	
  data() {
    return {
		    dialogImageUrl: '',
        dialogVisible: false,
		    isEdit:true
    }
  };
  private tableData: Array<any> = [];
  private pageNo = 1;
  private pageSize = 10;
  private form = {};
  private get pagedTableData() {
    return this.tableData.filter(
      (v, i) =>
        i >= (this.pageNo - 1) * this.pageSize &&
        i <= this.pageNo * this.pageSize - 1
    );
  }

  private mounted() {
    let datas = [];
	  let pageNum = 1;
	  let pageSize = 10;
    let paramter = {
		pageNum,
		pageSize
    };
    this.$http.get("brand/list", {paramter}).then((res: any) => {
    	datas = res.data.data.data;
    	this.tableData = datas;
    });
  }

  private handleSizeChange(val: number) {
    console.log(`每页 ${val} 条`);
    this.pageSize = val;
    this.pageNo = 1;
  }

  private handleCurrentChange(val: number) {
    console.log(`当前页: ${val}`);
    this.pageNo = val;
  }

  private onSubmit() {
    console.log(this.form);
  }
  private addSubmit(){

    console.log(this.form);
  }
  private userStateChange(item) {

    // 是否启用
    console.log(item);
  }
  private handleUpdate(index, row){
    // 编辑品牌
    console.log(row);
  }
  private handleDelete(index, row){
    // 删除品牌
    console.log(row);
  }
  private handleRemove(file, fileList) {
    console.log(file, fileList);
  }
  private handlePictureCardPreview(file) {
    this.dialogImageUrl = file.url;
    this.dialogVisible = true;
  }
}
